import React from "react";

const Privacy = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-center">
      <div className=" text-white py-32">
        <div className="py-4 max-w-3xl mx-auto bg-slate-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
          <p className="mb-2">
            <strong>Type of website:</strong> News or Media
          </p>
          <p className="mb-2">
            <strong>Effective date:</strong> 1st day of February, 2023
          </p>
          <p className="mb-4">
            <strong>www.iSiLIVE.ca</strong> (the "Site") is owned and operated
            by iSiLIVE. iSiLIVE is the data controller and can be contacted at:
          </p>
          <p className="mb-4">
            (888) 683-5727
            <br />
            <a href="mailto:support@isilive.ca" className="text-blue-500">
              support@isilive.ca
            </a>
            <br />
            150 Terence Matthews Crescent
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Purpose</h2>
            <p className="mb-2">
              The purpose of this privacy policy (this "Privacy Policy") is to
              inform users of our Site of the following:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>The personal data we will collect;</li>
              <li>Use of collected data;</li>
              <li>Who has access to the data collected;</li>
              <li>The rights of Site users; and</li>
              <li>The Site's cookie policy.</li>
            </ul>
            <p className="mb-4">
              This Privacy Policy applies in addition to the terms and
              conditions of our Site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">GDPR</h2>
            <p className="mb-4">
              For users in the European Union, we adhere to the Regulation (EU)
              2016/679 of the European Parliament and of the Council of 27 April
              2016, known as the General Data Protection Regulation (the
              "GDPR"). For users in the United Kingdom, we adhere to the GDPR as
              enshrined in the Data Protection Act 2018.
            </p>
            <p className="mb-4">
              We have not appointed a Data Protection Officer as we do not fall
              within the categories of controllers and processors required to
              appoint a Data Protection Officer under Article 37 of the GDPR.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Consent</h2>
            <p className="mb-2">
              By using our Site users agree that they consent to:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>The conditions set out in this Privacy Policy.</li>
            </ul>
            <p className="mb-4">
              When the legal basis for us processing your personal data is that
              you have provided your consent to that processing, you may
              withdraw your consent at any time. If you withdraw your consent,
              it will not make processing which we completed before you withdrew
              your consent unlawful.
            </p>
            <p className="mb-4">
              You can withdraw your consent by: Contacting the Data Protection
              Officer.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              Legal Basis for Processing
            </h2>
            <p className="mb-2">
              We collect and process personal data about users in the EU only
              when we have a legal basis for doing so under Article 6 of the
              GDPR.
            </p>
            <p className="mb-4">
              We rely on the following legal basis to collect and process the
              personal data of users in the EU:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>
                Users have provided their consent to the processing of their
                data for one or more specific purposes.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              Personal Data We Collect
            </h2>
            <p className="mb-2">
              We only collect data that helps us achieve the purpose set out in
              this Privacy Policy. We will not collect any additional data
              beyond the data listed below without notifying you first.
            </p>
            <h3 className="text-xl font-semibold mb-2">
              Data Collected in a Non-Automatic Way
            </h3>
            <p className="mb-2">
              We may also collect the following data when you perform certain
              functions on our Site:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Email address.</li>
            </ul>
            <p className="mb-4">
              This data may be collected using the following methods:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>User opt-in account creation.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              How We Use Personal Data
            </h2>
            <p className="mb-2">
              Data collected on our Site will only be used for the purposes
              specified in this Privacy Policy or indicated on the relevant
              pages of our Site. We will not use your data beyond what we
              disclose in this Privacy Policy.
            </p>
            <p className="mb-4">
              The data we collect when the user performs certain functions may
              be used for the following purposes:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Authentication to view protected content; and</li>
              <li>Identify a user in a public chat room.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              Who We Share Personal Data With
            </h2>
            <h3 className="text-xl font-semibold mb-2">Employees</h3>
            <p className="mb-4">
              We may disclose user data to any member of our organization who
              reasonably needs access to user data to achieve the purposes set
              out in this Privacy Policy.
            </p>
            <h3 className="text-xl font-semibold mb-2">Other Disclosures</h3>
            <p className="mb-4">
              We will not sell or share your data with other third parties,
              except in the following cases:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>If the law requires it;</li>
              <li>If it is required for any legal proceeding;</li>
              <li>To prove or protect our legal rights; and</li>
              <li>
                To buyers or potential buyers of this company in the event that
                we seek to sell the company.
              </li>
            </ul>
            <p className="mb-4">
              If you follow hyperlinks from our Site to another Site, please
              note that we are not responsible for and have no control over
              their privacy policies and practices.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              How Long We Store Personal Data
            </h2>
            <p className="mb-4">
              User data will be stored until the purpose the data was collected
              for has been achieved. You will be notified if your data is kept
              for longer than this period.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              How We Protect Your Personal Data
            </h2>
            <p className="mb-2">
              In order to protect your security, we use the strongest available
              browser encryption and store all of our data on servers in secure
              facilities. All data is only accessible to our employees. Our
              employees are bound by strict confidentiality agreements and a
              breach of this agreement would result in the employee's
              termination.
            </p>
            <p className="mb-4">
              While we take all reasonable precautions to ensure that user data
              is secure and that users are protected, there always remains the
              risk of harm. The Internet as a whole can be insecure at times and
              therefore we are unable to guarantee the security of user data
              beyond what is reasonably practical.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              Your Rights as a User
            </h2>
            <p className="mb-4">
              Under the GDPR, you have the following rights:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Right to be informed;</li>
              <li>Right of access;</li>
              <li>Right to rectification;</li>
              <li>Right to erasure;</li>
              <li>Right to restrict processing;</li>
              <li>Right to data portability; and</li>
              <li>Right to object.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Children</h2>
            <p className="mb-2">
              We do not knowingly collect or use personal data from children
              under 16 years of age. If we learn that we have collected personal
              data from a child under 16 years of age, the personal data will be
              deleted as soon as possible. If a child under 16 years of age has
              provided us with personal data their parent or guardian may
              contact our privacy officer.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              How to Access, Modify, Delete, or Challenge the Data Collected
            </h2>
            <p className="mb-4">
              If you would like to know if we have collected your personal data,
              how we have used your personal data, if we have disclosed your
              personal data and to who we disclosed your personal data, if you
              would like your data to be deleted or modified in any way, or if
              you would like to exercise any of your other rights under the
              GDPR, please contact our privacy officer here:
            </p>
            <p className="mb-4">
              <a href="mailto:support@iSiLIVE.ca" className="text-blue-500">
                support@iSiLIVE.ca
              </a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              How to Opt-Out of Data Collection, Use or Disclosure
            </h2>
            <p className="mb-4">
              In addition to the method(s) described in the How to Access,
              Modify, Delete, or Challenge the Data Collected section, we
              provide the following specific opt-out methods for the forms of
              collection, use, or disclosure of your personal data specified
              below:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>
                You can opt-out of the use of your personal data for marketing
                emails. You can opt-out by clicking "unsubscribe" on the bottom
                of any marketing email.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Cookie Policy</h2>
            <p className="mb-4">
              A cookie is a small file, stored on a user's hard drive by a
              website. Its purpose is to collect data relating to the user's
              browsing habits. You can choose to be notified each time a cookie
              is transmitted. You can also choose to disable cookies entirely in
              your internet browser, but this may decrease the quality of your
              user experience.
            </p>
            <p className="mb-4">
              We use the following types of cookies on our Site:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>
                <strong>Functional cookies</strong> are used to remember the
                selections you make on our Site so that your selections are
                saved for your next visits.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Modifications</h2>
            <p className="mb-4">
              This Privacy Policy may be amended from time to time in order to
              maintain compliance with the law and to reflect any changes to our
              data collection process. When we amend this Privacy Policy we will
              update the "Effective Date" at the top of this Privacy Policy. We
              recommend that our users periodically review our Privacy Policy to
              ensure that they are notified of any updates. If necessary, we may
              notify users by email of changes to this Privacy Policy.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Complaints</h2>
            <p className="mb-4">
              If you have any complaints about how we process your personal
              data, please contact us through the contact methods listed in the
              Contact Information section so that we can, where possible,
              resolve the issue. If you feel we have not addressed your concern
              in a satisfactory manner you may contact a supervisory authority.
              You also have the right to directly make a complaint to a
              supervisory authority.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
